import { Injectable } from '@angular/core';
import { dbConst } from './databaseConstants';
import { FirestoreCrudService } from './crudService';
import { AuthService } from '../auth.service';
import { Firestore } from '@angular/fire/firestore';
import { map } from 'rxjs';
import { ICan } from 'app/models/can';

@Injectable({
  providedIn: 'root'
})
export class CanService {

  private crudService: FirestoreCrudService<ICan>;

  constructor(
    firestore: Firestore,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<ICan>(firestore, authService, dbConst.cans);
  }


  getNewId() {
    return this.crudService.getNewId();
  }

  getItem(id: string) {
    return this.crudService.get(id);
  }

  getItems(barId: string, limit = undefined) {
    return this.crudService
      .getItems(barId, limit)
      .pipe(
        map(changes => {
          return changes.map(a => {
            const data = a as ICan;
            return data;
          });
        })
      )
  }



  update(item: ICan) {
    return this.crudService.update(item);
  }

  add(item: ICan, id: string | undefined = undefined) {
    return this.crudService.add({ ...item }, id);
  }

  async softUpdate(id: string, data: any, uid: string) {
    return await this.crudService.softUpdate(id, data, uid);
  }


  async updateItem(item: ICan) {
    return await this.crudService.update(item);
  }


  delete(id: string) {
    return this.crudService.delete(id);
  }


}
